import { attentionIcon } from '@/images'
import { GxIcon, GxTextarea } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import ErrorText from '../ErrorText'
import style from './styles/textarea.module.scss'

interface IProps {
  value?: string
  name?: string
  theme?: string
  className?: string
  required?: boolean
  error?: string
  label?: string
  placeholder?: string
  resize?: 'none' | 'vertical' | 'auto'
  rows?: number
}

const Textarea = ({
  children,
  className = '',
  label = '',
  theme = 'gray',
  required = false,
  error = '',
  resize = 'none',
  rows,
  ...props
}: React.PropsWithChildren<IProps>): React.ReactElement => {
  return (
    <GxTextarea
      label={label}
      required={required}
      data-error={error}
      resize={resize}
      rows={rows}
      className={classNames({
        [style.default]: true,
        [style[`theme_${theme}`]]: theme,
        [className]: Boolean(className)
      })}
      {...props}
    >
      {error !== ''
        ? (
          <>
            <GxIcon
              src={attentionIcon}
              slot='suffix'
              className={style.icon_error}
            />
            <ErrorText text={error} />
          </>
          )
        : undefined}
    </GxTextarea>
  )
}

export default Textarea
